"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
require("swiper/css");
require("swiper/css/navigation");
var react_1 = require("react");
var swiper_1 = require("swiper");
var react_2 = require("swiper/react");
var useRequests_1 = __importDefault(require("../../hooks/useRequests"));
var WinnersSlide_1 = __importDefault(require("./WinnersSlide"));
var WinnersWidget = function (_a) {
    var _b = _a.title, title = _b === void 0 ? "CELE MAI MARI CÂȘTIGURI DE AZI" : _b;
    var getWinnersWidgetData = (0, useRequests_1.default)().getWinnersWidgetData;
    var _c = (0, react_1.useState)([]), data = _c[0], setData = _c[1];
    var _d = (0, react_1.useState)(false), isMobile = _d[0], setIsMobile = _d[1];
    var nextButton = (0, react_1.useRef)(null);
    var prevButton = (0, react_1.useRef)(null);
    var onResize = function () {
        setIsMobile(window.innerWidth < 700);
    };
    (0, react_1.useEffect)(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getWinnersWidgetData()];
                    case 1:
                        res = _a.sent();
                        setData(res.response);
                        return [2 /*return*/];
                }
            });
        }); })();
        onResize();
        window.addEventListener("resize", onResize);
        return function () { return window.removeEventListener("resize", onResize, false); };
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "winnersWidget-container" }, { children: [(0, jsx_runtime_1.jsx)("h3", { children: title }), (0, jsx_runtime_1.jsxs)(react_2.Swiper, __assign({ breakpoints: {
                    320: {
                        slidesPerView: 1.5,
                        spaceBetween: 10,
                    },
                    420: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    600: {
                        slidesPerView: 2.5,
                    },
                    650: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    700: {
                        slidesPerView: 2.5,
                    },
                    800: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    900: {
                        slidesPerView: 3.5,
                        spaceBetween: 50,
                    },
                    1000: {
                        slidesPerView: 4,
                    },
                    1200: {
                        slidesPerView: 4.5,
                    },
                }, spaceBetween: 50, slidesPerView: 4.5, navigation: {
                    nextEl: nextButton.current,
                    prevEl: prevButton.current,
                    hiddenClass: "nav-button-hidden",
                    disabledClass: "nav-button-hidden",
                }, modules: [swiper_1.Navigation, swiper_1.Controller], direction: "horizontal", loop: false }, { children: [data.map(function (item, idx) { return (0, jsx_runtime_1.jsx)(WinnersSlide_1.default, { isMobile: isMobile, item: item }, idx); }), (0, jsx_runtime_1.jsx)("div", __assign({ ref: nextButton, className: "nav-button-shadow nav-button-shadow--right" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "material-icons next-button" }, { children: "arrow_forward" })) })), (0, jsx_runtime_1.jsx)("div", __assign({ ref: prevButton, className: "nav-button-shadow nav-button-shadow--left" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "material-icons prev-button" }, { children: "arrow_back" })) }))] }))] })));
};
exports.default = WinnersWidget;
